/**
 * 公共方法
 */

let moment = require("moment");

/**
 * 日期格式化 时间戳转换时间
 * @param date 传入时间戳
 * @param format 格式示例：YYYY-MM-DD
 */
function timeStampForTime(date, format) {
  if (!date) return '';
  return moment(date).format(format);
}

/**
 * 时间转时间戳
 * @param date 传入时间
 */
function timeForTimeStamp(date) {
  let time = moment(date).valueOf();
  if (date === 0 || date === '' || date === undefined) {
    return '';
  } else {
    return time
  }
}

/**
 * @param {string} name 需要获取的名称
 * @param {boolean} flag 是否需要序列化 默认序列化
 */
const getLocal = (name, flag = true) => {
  if (flag) {
    return JSON.parse(window.localStorage.getItem(name));
  }
  return window.localStorage.getItem(name)
}

const setLocal = (name, value) => {
  window.localStorage.setItem(name, JSON.stringify(value))
}

const removeLocal = (key) => {
  window.localStorage.removeItem(key)
}
const clearLocal = () => {
  window.localStorage.clear();
}

//从menuList中获取menuId
function getMenuArr(title, arr) {
  // let arr = this.getLocal('menuList')
  let list = ''
  arr.map(item => {
    if (item.menuName === title) {
      list = item.children
    }
  })
  return list
}




module.exports = {
  timeStampForTime, timeForTimeStamp,
  getLocal, setLocal, removeLocal, clearLocal,
  getMenuArr
};